import { generateReducer, } from "../generators/generator.reducer";
import { GENERATOR_PARAMS } from "./payin.constants";
var reducer = generateReducer(GENERATOR_PARAMS);
// eslint-disable-next-line import/no-default-export
export default reducer;
